import { gql } from '@apollo/client';

export const QUERY_CLASSE_WITH_NOTE_AND_STUDENTS_ORDERS = gql`
  query getClasseWithNoteAndStudentsOrders($userId: ID!) {
    getClasseWithNoteAndEleves {
      ong
      percentDedicatedToOng
      users {
        commandes {
          status
          customerContributedToTheOng
        }
        note {
          qteca
        }
      }
      noteclasse {
        qteca
      }
    }
    getMyOrdersInClasse(userId: $userId) {
      commandes {
        attributes {
          status
          customerContributedToTheOng
        }
      }
    }
    getMyNoteInClasse(userId: $userId) {
      note {
        attributes {
          qteca
        }
      }
    }
    usersPermissionsUser(id: $userId) {
      data {
        id
        attributes {
          ong
        }
      }
    }
  }
`;
